<template>

    <router-link :to="route" :class="{'bg-light-gray': isCurrentRoute() }" class="hover-bg-near-white pointer black bb b--light-gray flex items-center justify-between no-underline">

        <div class="flex items-center">
            <!-- menu image -->
            <img v-if="image !== null" class="mr3" :src="image">
            <!-- menu title -->
            <h6 class="pv3">{{title}}</h6>
        </div>

        <div class="flex items-center">
            <!-- counter -->
            <Pill v-if="count !== null" :count="count"/>
            <!-- arrow -->
            <img class="pl2" src="@/assets/img/icon_forward_simple_yellow.svg">
        </div>

    </router-link>

</template>

<script>
import Pill from '@/components/controls/Pill.vue';

export default {
    components: {
        Pill
    },
    props: {
        image: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            required: true
        },
        route: {
            type: String,
            required: true
        },
        count: {
            type: Number,
            default: null
        },
        childRoutes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        height: {}
    },
    methods: {
        isCurrentRoute() {
            var routes = [this.route, ...this.childRoutes];

            return routes.some(element => {
                return this.$route.path.startsWith(element);
            });
        }
    }
};
</script>

<style scoped>
.pill {
    background-color: #ffbb00;
    padding: 3px 9px;
    border-radius: 16px;
}
</style>
